export default "<a href=\"{{$ctrl.yt_url}}\" target=\"_blank\"><img src=\"{{$ctrl.logo_img}}\" style=\"height:20px;margin:{{$ctrl.margins}};\" /></a>";